export const SEARCH_ITEM_REPAIR_ASYNC = 'SEARCH_ITEM_REPAIR_ASYNC';
export const SEARCH_ITEM_REPAIR_SUCCESS = 'SEARCH_ITEM_REPAIR_SUCCESS';
export const SEARCH_PROBLEM_ASYNC = 'SEARCH_PROBLEM_ASYNC';
export const SEARCH_PROBLEM_SUCCESS = 'SEARCH_PROBLEM_SUCCESS';
export const CREATE_ITEM_REPAIR_ASYNC = 'CREATE_ITEM_REPAIR_ASYNC';
export const UPDATE_ITEM_REPAIR_ASYNC = 'UPDATE_ITEM_REPAIR_ASYNC';
export const CREATE_PROBLEM_ASYNC = 'CREATE_PROBLEM_ASYNC';
export const UPDATE_PROBLEM_ASYNC = 'UPDATE_PROBLEM_ASYNC';
export const MAKE_ACTIVE_ITEM_REPAIR_ASYNC = 'MAKE_ACTIVE_ITEM_REPAIR_ASYNC';
export const MAKE_INACTIVE_ITEM_REPAIR_ASYNC = 'MAKE_INACTIVE_ITEM_REPAIR_ASYNC';
export const MAKE_ACTIVE_PROBLEM_ASYNC = 'MAKE_ACTIVE_PROBLEM_ASYNC';
export const MAKE_INACTIVE_PROBLEM_ASYNC = 'MAKE_INACTIVE_PROBLEM_ASYNC';
export const OPEN_FORM_CREATE_ITEM_REPAIR = 'OPEN_FORM_CREATE_ITEM_REPAIR';
export const OPEN_FORM_CREATE_PROBLEM = 'OPEN_FORM_CREATE_PROBLEM';
export const CLOSE_FORM_CREATE_PROBLEM = 'CLOSE_FORM_CREATE_PROBLEM';
export const GET_ITEM_REPAIR_BY_ID_ASYNC = 'GET_ITEM_REPAIR_BY_ID_ASYNC';
export const GET_ITEM_REPAIR_BY_ID_SUCCESS = 'GET_ITEM_REPAIR_BY_ID_SUCCESS';
export const GET_PROBLEM_BY_ID_ASYNC = 'GET_PROBLEM_BY_ID_ASYNC';
export const GET_PROBLEM_BY_ID_SUCCESS = 'GET_PROBLEM_BY_ID_SUCCESS';
export const ADD_EDIT_ITEM_REPAIR_ERROR = 'ADD_EDIT_ITEM_REPAIR_ERROR';
export const RESET_ITEM_REPAIR = 'RESET_ITEM_REPAIR';
export const SELECT_LIST_ITEM_REPAIR_ASYNC = 'SELECT_LIST_ITEM_REPAIR_ASYNC';
export const SELECT_LIST_ITEM_REPAIR_SUCCESS = 'SELECT_LIST_ITEM_REPAIR_SUCCESS';
export const SELECT_LIST_PROBLEM_ASYNC = 'SELECT_LIST_PROBLEM_ASYNC';
export const SELECT_LIST_PROBLEM_SUCCESS = 'SELECT_LIST_PROBLEM_SUCCESS';
export const RESET_PROBLEM = 'RESET_PROBLEM';
export const SELECT_LIST_BLUE_TAPE_PROBLEM_ASYNC = "SELECT_LIST_BLUE_TAPE_PROBLEM_ASYNC";
export const SELECT_LIST_BLUE_TAPE_PROBLEM_SUCCESS = "SELECT_LIST_BLUE_TAPE_PROBLEM_SUCCESS"



// WEBPACK FOOTER //
// ./src/Items/constants.js